import React, { useContext, useState } from 'react';
import { Context } from '../../../context/global-data-provider';
import api from '../../../api/api';
import { useAlert } from 'react-alert';
import Svg from '../icons/svg';
import LoadingInCenter from '../loading/loading-in-center';

const RestorePost = (props) => {
  const postData = props.data ? props.data : false;
  const [loading, setLoading] = useState(false);
  const { post } = useContext(Context);
  const alert = useAlert();

  const onRestoreHandler = () => {
    setLoading(true);
    api.restorePost({ id: props.id }).then((response) => {
      const { status, message } = response;

      if (status === 'ok') {
        alert.success(message);

        if (postData) {
          // in sm mode.
          props.updateSmPost({
            trash: '0',
          });
        } else {
          // in lg mode.
          post.update({
            trash: '0',
          });
        }

        setLoading(false);
      } else {
        alert.error(message);
      }
    });
  };

  return (
    <>
      <div className="restore-post">
        <LoadingInCenter blur show={loading} width={12} height={12} />
        <button type="button" className="btn text-success" onClick={onRestoreHandler} disabled={loading}>
          <Svg name={'restore'} width={14} />
        </button>
      </div>
    </>
  );
};

export default React.memo(RestorePost);
